<template>
  <div class="bg-[#0963FF1A] h-[0.55rem] md:h-[0.6rem] 3xl:h-[0.625rem] w-full"/>
</template>